module.exports = __webpack_public_path__ + "static/media/associates.44152d36.png";